// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Login from './components/login/Login';
import Home from './components/home/Home';
import MyExams from './components/examens/MyExams';
import MyNotifications from './components/MyNotifications';
import MyProfile from './components/MyProfile';
import Logout from './components/Logout';
import DetailExam from './components/detailExams/DetailExam';
import LoadDicom from './components/loadDicom/LoadDicom';
import Rapport from './components/rapport/Rapport';
import Profil from './components/profil/Profil';
import RapportTypes from "./components/RapportTypes/RapportTypes";
import DICOMUploader from './components/DICOMUploader/DICOMUploader';
import PublicViewerImages from "./components/PublicViewerImages/PublicViewerImages";
import RapportQR from './components/RapportQR/RapportQR';

const App = () => {
  return (
    <Router>
  
      <div className="content">
        <Routes>
          <Route exact path="/" element={ <Login />} />
          <Route path="/accueil" element={ <Home />} />
          <Route path="/mes-examens" element={ <MyExams />} />
          <Route path="/chargement-fichier" element={ <LoadDicom />} />
          <Route path="/mes-notifications" element={ <MyNotifications />} />
          <Route path="/examens/:publicId" element={<DetailExam />} />
          <Route path="/rapport/:publicId" element={<Rapport />} />
          <Route path="/mon-profil" element={ <MyProfile />} />
          <Route path="/deconnexion" element={ <Logout />} />
          <Route path="/profil" element={ <Profil />} />
          <Route path="/load" element={ <DICOMUploader />} />
          <Route path="/saisie" element={<RapportTypes />} />
          <Route path="/public/viewer/:publicId" element={<PublicViewerImages />} />
          <Route path="/rapport-qr/:publicId" element={<RapportQR />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
